<template>
  <div class="sidebar"
        :data-color="backgroundColor"
        :data-active-color="activeColor">
    <div class="logo">
      <a class="simple-text logo-mini"
          aria-label="sidebar mini logo"
          href="/">
          <div>
              <img :src="logo" alt="">
          </div>

      </a>
      <a class="simple-text logo-normal"
          href="/">
          {{ title }}
      </a>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in finalSidebar"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
  import SecureLS from 'secure-ls'
  export default {
    props: {
      title: {
        type: String,
        default: 'EMI',
        description: 'Banco Mundo Mujer S.A'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'warning',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        // default: 'static/img/vue-logo.png',
        default: process.env.VUE_APP_BASE_ROUTE+'img/sphere-bmm.png',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      
    },
    data() {
      return {
        finalSidebar: [
          {
            name: 'Dashboard',
            icon: 'nc-icon nc-bank',
            path: '/admin/overview'
          },
          {
            name: 'Mantenimiento',
            icon: 'nc-icon nc-tap-01',
            path: '/admin/maintenance'
          },
        ]
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
